import moment from "moment"
import { lineName, placeName, plural } from "pages/EventsManagement/components/Tabs/Logistics/labels"
import { shipmentNoun } from "pages/EventsManagement/components/Tabs/Logistics/shipmentLabels"
import { filterParams } from "../addressFilters"

// The filters the page keeps in its address, as the API reads them (ticket 18, Q3); `view` only picks the table.
export const FILTERS = ["from", "to", "clubId", "organizerId", "category", "sportType", "status", "withSignals", "includeDisabled", "clubLines"]

// The filter the page shows, with the period the API chose, as the export's parameters.
export const exportParams = filter => filterParams(filter, FILTERS)

// "3–4 Oct 2026", "31 Oct – 1 Nov 2026", "30 Dec 2026 – 2 Jan 2027": an event's days.
export const datesLabel = (start, end) => {
  const [first, last] = [moment(start, "YYYY-MM-DD", true), moment(end || start, "YYYY-MM-DD", true)]
  if (!first.isValid()) return "Dates not recorded"
  if (!last.isValid() || last.isSame(first, "day")) return first.format("D MMM YYYY")
  if (last.isSame(first, "month")) return `${first.format("D")}–${last.format("D MMM YYYY")}`
  if (last.isSame(first, "year")) return `${first.format("D MMM")} – ${last.format("D MMM YYYY")}`
  return `${first.format("D MMM YYYY")} – ${last.format("D MMM YYYY")}`
}

export const sheetStates = { inPreparation: { label: "In progress", color: "soft-warning" },
  readyForProcessing: { label: "Ready for processing", color: "soft-info" }, readyToShip: { label: "Ready to be shipped", color: "soft-primary" },
  shipped: { label: "Shipped", color: "soft-success" }, noShipment: { label: "No shipment", color: "soft-secondary" } }
// The event's own state, shown only when it is no longer active.
export const eventStateLabel = status => ({ DISABLED: "Disabled", DELETED: "Deleted" })[status] || null

// What a sheet in preparation still needs (the sheet summary's marks), as the page and its export write it; or, for a canceled event whose
// goods left, the shipments whose return is awaited (D10).
const signals = {
  toComplete: { name: "To complete", color: "soft-danger", parts: ({ lines, delivery }) => [lines ? plural(lines, "line") : null, delivery ? "delivery" : null] },
  toCheck: { name: "To check", color: "soft-warning",
    parts: ({ lines, delivery }) => [lines ? plural(lines, "line") : null, delivery ? plural(delivery, "delivery change") : null] },
  toConfirm: { name: "To confirm", color: "soft-warning", parts: () => ["delivery address"] },
  estimated: { name: "Estimated", color: "soft-info", parts: ({ competitions }) => [plural(competitions, "competition")] },
  canceledAfterShipment: { name: "Canceled after shipment", color: "soft-danger",
    text: ({ shipments }) => `Canceled after shipment · record the return (${shipments.map(shipmentNoun).join(", ")})` },
}
export const signalName = signal => signals[signal.kind]?.name || signal.kind
export const signalLabel = signal => signals[signal.kind]?.text?.(signal)
  || `${signalName(signal)}: ${(signals[signal.kind]?.parts(signal) || []).filter(Boolean).join(", ")}`
export const signalColor = signal => signals[signal.kind]?.color || "soft-secondary"

// "Medals Silver · Champion", "Balls TBD": a product row, by its product or, without one, by its family.
export const productLabel = row => [lineName(row, row.officialBall), row.place && placeName(row.place)].filter(Boolean).join(" · ")
